/**
 * Faixa verde de troca/avaliação.
 * Porte de `bicicletas_peniel_prototipo.html` linhas 296-304.
 */
import { MENSAGENS } from '@peniel/shared'

import { BotaoWhatsAppGeral } from './BotaoWhatsApp.jsx'

export function BannerTroca() {
  return (
    <section className="bg-brand-700 py-16" aria-labelledby="titulo-troca">
      <div className="mx-auto max-w-4xl px-4 text-center">
        <h2 id="titulo-troca" className="mb-4 text-3xl font-bold text-white">
          Tem uma bicicleta encostada?
        </h2>
        <p className="mb-8 text-lg text-brand-50">
          Nós avaliamos e compramos a sua bicicleta usada ou aceitamos como parte do pagamento em
          uma nova.
        </p>
        <BotaoWhatsAppGeral
          mensagem={MENSAGENS.avaliarBike}
          variante="branca"
          tamanho="lg"
          className="text-brand-700"
        >
          Quero avaliar minha bike
        </BotaoWhatsAppGeral>
      </div>
    </section>
  )
}
